<button (click)="click.next(); $event.stopPropagation()"
    class="flex flex-row items-center flex-auto ajin-card w-full bg-input-hover gap-4 px-3 py-2 text-default" [disabled]="disabled" [class.disabled]="disabled">
    <mat-icon [class.icon-size-5]="leftIconSize==='small'" [style.color]="leftIconColor" [svgIcon]="leftIcon" *ngIf="leftIcon"> </mat-icon>
    <span class="flex flex-auto"> {{label}}</span>
    <mat-icon  [class.icon-size-5]="rightIconSize==='small'" [style.color]="rightIconColor" [svgIcon]="rightIcon" *ngIf="rightIcon">
    </mat-icon>
</button>
